import { GridState } from "@ag-grid-community/core";
import { Flex } from "@chakra-ui/react";
import { FundFamilySelect } from "features/transactions/TransactionsViewTable/CalculationActions/FundFamilySelect";
import { TransactionCalculationDropdown } from "features/transactions/TransactionsViewTable/CalculationActions/TransactionCalculationDropdown";
import { useAgGridEventState } from "shared/components/table/ag/AgGridEventState";
import { TableBoxHeader } from "shared/components/table/box/TableBoxHeader";
import { useMaybernTableUIContext } from "shared/components/table/maybern/MaybernTableUIContext";

export const CalculationActions = ({
  fundFamilyIds,
  setFundFamilyIds,
  transactionCalculationId,
  setTransactionCalculationId,
  initialState,
}: {
  fundFamilyIds: string[];
  setFundFamilyIds: (fundFamilyId: string[]) => void;
  transactionCalculationId: string | null | undefined;
  setTransactionCalculationId: (calcId: string) => void;
  initialState: GridState;
}) => {
  const { agGrid } = useMaybernTableUIContext();
  const isPivoting = useAgGridEventState(
    agGrid,
    "columnPivotModeChanged",
    (api) => api.isPivotMode(),
  );
  if (!isPivoting) return null;

  return (
    <TableBoxHeader
      width="100%"
      display="flex"
      height="55px"
      justifyContent="flex-end"
    >
      <Flex columnGap="24px" alignItems="center">
        <FundFamilySelect
          fundFamilyIds={fundFamilyIds}
          setFundFamilyIds={setFundFamilyIds}
          setTransactionCalculationId={setTransactionCalculationId}
        />
        <TransactionCalculationDropdown
          initialState={initialState}
          fundFamilyIds={fundFamilyIds}
          transactionCalculationId={transactionCalculationId}
          setCalculationId={setTransactionCalculationId}
          isDisabled={fundFamilyIds.length > 1}
        />
      </Flex>
    </TableBoxHeader>
  );
};
